import React, { Component } from 'react';
import update from 'immutability-helper'
import Card from './card';
import { DropTarget } from 'react-dnd';
var dateFormat = require('dateformat');

class DragContainer extends Component {

	constructor(props) {
		super(props);		
		this.state = { cards: props.list };
	}

	pushCard(card) {
		this.setState(update(this.state, {
			cards: {
				$push: [ card ]
			}
		}));
	}

	removeCard(index) {		
		this.setState(update(this.state, {
			cards: {
				$splice: [
					[index, 1]
				]
			}
		}));
	}

	moveCard(dragIndex, hoverIndex) {
		
		const { cards } = this.state;		
		const dragCard = cards[dragIndex];

		this.setState(update(this.state, {
			cards: {
				$splice: [
					[dragIndex, 1],
					[hoverIndex, 0, dragCard]
				]
			}
		}));
	}

	render() {
		const { cards } = this.state;
		const { canDrop, isOver, connectDropTarget,name,user_data,toggle,month_name } = this.props;
		const isActive = canDrop && isOver;
		const style = {
			width: "200px",
			height: "404px",
			border: '1px dashed gray'
		};

		const backgroundColor = isActive ? 'lightgreen' : '#FFF';

		return connectDropTarget(
			<div className="sched-col-wrap">
				<div className="sched-col__header">{name}</div>
				<div className={`sched-col__body${isActive ? ' sched-col--active' : ''}`}>
					{cards.map((card, i) => (
						<Card
							key={card.id}
							index={i}
							listId={this.props.id}
							card={card}
							users={card.user_list}
							toggle={toggle}
							removeCard={this.removeCard.bind(this)}
							moveCard={this.moveCard.bind(this)}
							id={card.id}
							status_code={card.status}
							is_charged={card.is_seperately_charge}
							periodical_name={card.periodical_name}
							freq={card.periodical_name.slice(0,1)}
							date={card.planned_start_date_time}
							facility_name={card.contract_facility_name}
							onClick={() => this.cardClick(card.id)}
						/>
					))}
				</div>
			</div>
		);
  }
}

const cardTarget = {
	canDrop (props,monitor) {
		const { id } = props;
		const sourceObj = monitor.getItem();
		var drag_month = new Date(id);
		var month_id=drag_month.getMonth();
		month_id=month_id+1;

		var month= new Date();
		var month_id_new=month.getMonth();
		month_id_new=month_id_new+1;

		var planned_start_date_time=sourceObj.card.planned_start_date_time;
		var start_date_time = planned_start_date_time.split("-");
		var old_planed_date=new Date(start_date_time[0], start_date_time[1], start_date_time[2]);
		var current_month=old_planed_date.getMonth();

		console.log(month_id_new+"current "+month_id);
		if(  month_id>=month_id_new){
			return true
		}
		else
		{
			return false
		}
		
	  },
	drop(props, monitor, component ) 
	{
		const { id } = props;
		//console.log("drag event "+id);
		//var drag_month=id;
		var drag_month = new Date(id);
		//this.props.cardClick();
		//console.log(props);
		
		//console.log(drag_month.getMonth()); // (January gives 0)

		var month_id=drag_month.getMonth();

		var month=month_id+1;

		//console.log(month); 
		
		//console.log(month_name.getMonth());
		const sourceObj = monitor.getItem();
		var planned_start_date_time=sourceObj.card.planned_start_date_time;
		var exist_month=sourceObj.card.planned_start_date_time;
		var card_id=sourceObj.card.id;
		var reason='';


		var start_date_time = planned_start_date_time.split("-");
		var new_planned_start_date_time = new Date(start_date_time[0], month_id, start_date_time[2]);
		var old_planed_date=new Date(start_date_time[0], start_date_time[1], start_date_time[2]);

		//console.log(new_planned_start_date_time.getMonth());
		var current_month=old_planed_date.getMonth();
		//current_month=current_month+1;

		var post={
			planned_start_date_time:new_planned_start_date_time,
			reason:'',
			id:sourceObj.card.id
		}

		//console.log(month+""+current_month);
		if(month!=current_month)
		{
			props.cardClick(post);
		}

		//console.log(sourceObj.card.status);
		if(sourceObj.card.status==3 || sourceObj.card.status==4 || sourceObj.card.status==5 ){
		}
		else
		{
			//console.log(sourceObj.card)
			//console.log()
			var date=dateFormat(new_planned_start_date_time,"yyyy-mm-dd");
			//planned_start_date_time
			var newData=sourceObj.card;
			//console.log(newData.contract_facility_name);
			// var list_element = newData.filter(function(y) 
			// {
			// 	//  return y.id == e 
			// 	console.log(y)
			// 	});
			var new_element={contract_facility_name:newData.contract_facility_name,contract_facility_periodical_id:newData.contract_facility_periodical_id,frequency_name:newData.frequency_name,icon:newData.icon,id:newData.id,is_seperately_charge:newData.is_seperately_charge,periodical_name:newData.periodical_name,planned_start_date_time:date,status:newData.status,user_list:newData.user_list}
			console.log(new_element);

			if ( id !== sourceObj.listId ) component.pushCard(new_element);
			return {
				listId: id
			};
		}
		
	}
}

export default DropTarget("CARD", cardTarget, (connect, monitor) => ({
	connectDropTarget: connect.dropTarget(),
	isOver: monitor.isOver(),
	canDrop: monitor.canDrop()
}))(DragContainer);


// WEBPACK FOOTER //
// ./src/shared/containers/PeriodicalScheduling/drag_container.js